<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h10">Copyright</h1>
<p class="p2"><span class="t2">Published by</span></p>
<p class="p2"><span class="t2">Dreamspinner Press</span></p>
<p class="p2"><span class="t2">5032 Capital Circle SW<br/>Suite 2, PMB# 279<br/>Tallahassee, FL 32305-7886 </span></p>
<p class="p2"><span class="t2">USA</span></p>
<p class="p3"><span class="t2">http://www.dreamspinnerpress.com/</span></p>
<p class="p3"><span class="t2">This is a work of fiction. Names, characters, places, and incidents either are the product of author imagination or are used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events, or locales is entirely coincidental. </span></p>
<p class="p2"><span class="t2">Exodus</span></p>
<p class="p3"><span class="t2">© 2014 CC Bridges.</span></p>
<p class="p2"><span class="t2">Cover Art </span></p>
<p class="p2"><span class="t2">© 2014 L.C. Chase.</span></p>
<p class="p2"><span class="t2">http://www.lcchase.com</span></p>
<p class="p3"><span class="t2">Cover content is for illustrative purposes only and any person depicted on the cover is a model.</span></p>
<p class="p3"><span class="t2">All rights reserved. This book is licensed to the original purchaser only. Duplication or distribution via any means is illegal and a violation of international copyright law, subject to criminal prosecution and upon conviction, fines, and/or imprisonment. Any eBook format cannot be legally loaned or given to others. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without the written permission of the Publisher, except where permitted by law. To request permission and all other inquiries, contact Dreamspinner Press, 5032 Capital Circle SW, Suite 2, PMB# 279, Tallahassee, FL 32305-7886, USA, or http://www.dreamspinnerpress.com/.</span></p>
<p class="p2"><span class="t2">ISBN: 978-1-62798-530-7</span></p>
<p class="p3"><span class="t2">Digital ISBN: 978-1-62798-531-4</span></p>
<p class="p2"><span class="t2">Printed in the United States of America</span></p>
<p class="p2"><span class="t2">First Edition</span></p>
<p class="p2"><span class="t2">March 2014</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?0871d12e